import { getEnv } from "../../config/getEnv";

/**
 * Conditional logger middleware for Redux
 * Only logs when REACT_APP_ENABLE_REDUX_LOGGER=true
 * Provides pretty-printed action and state information
 */
const loggerMiddleware = (store) => (next) => (action) => {
  // Only log if explicitly enabled via environment variable
  if (getEnv("REACT_APP_ENABLE_REDUX_LOGGER") === "true") {
    const prevState = store.getState();

    console.group(
      `%c Action: ${action.type}`,
      "color: #4CAF50; font-weight: bold",
    );
    console.log(
      "%c Previous State:",
      "color: #9E9E9E; font-weight: bold",
      prevState,
    );
    console.log("%c Action:", "color: #03A9F4; font-weight: bold", action);

    const result = next(action);

    const nextState = store.getState();
    console.log(
      "%c Next State:",
      "color: #4CAF50; font-weight: bold",
      nextState,
    );
    console.groupEnd();

    return result;
  }

  // If logging disabled, just pass through
  return next(action);
};

export default loggerMiddleware;
